const menuData: Array<{}> = [
    {
        title: 'Menu',
        type: 'menu',
        subMenu: [
            {
                title: 'Home',
                activeImage: 'assets/images/side_icons/home.svg',
                inactiveImage: 'assets/images/side_icons/home-1.svg',
                route: '/home/dashboard',
            },
            {
                title: 'Manage Locations',
                activeImage: 'assets/images/side_icons/location.svg',
                inactiveImage: 'assets/images/side_icons/location-1.svg',
                route: `/home/location`,
            },
        ],
    },
    {
        title: 'Demands',
        type: 'demands',
        subMenu: [
            {
                title: 'Manage Demands',
                activeImage: 'assets/images/side_icons/demand.svg',
                inactiveImage: 'assets/images/side_icons/demand-1.svg',
                route: null,
                subMenu: [
                    {
                        title: 'Transporter',
                        route: '/home/demands',
                    },
                    {
                        title: 'Others',
                        route: '/home/others',
                    },
                ],
            },
            // {
            //     title: 'Finalised Bids',
            //     activeImage: 'assets/images/side_icons/finalised_bids.svg',
            //     inactiveImage: 'assets/images/side_icons/finalised_bids-1.svg',
            //     route: '/home/finalisedbids',
            // },
            {
                title: 'Finalized',
                activeImage: 'assets/images/side_icons/finalised_bids.svg',
                inactiveImage: 'assets/images/side_icons/finalised_bids-1.svg',
                route: null,
                subMenu: [
                    {
                        title: 'Transporter',
                        route: '/home/finalisedbids/transporter',
                    },
                    {
                        title: 'Other',
                        route: '/home/finalisedbids/other',
                    },
                ],
            },
        ],
    },
    // {
    //     title: 'Penalty',
    //     type: 'penalty',
    //     subMenu: [
    //         {
    //             title: 'Penalty Type',
    //             activeImage: 'assets/images/side_icons/penalty_type.svg',
    //             inactiveImage: 'assets/images/side_icons/penalty_type-1.svg',
    //             route: `/home/penalty`,
    //         },
    //         {
    //             title: 'Vendor Delays',
    //             activeImage: 'assets/images/side_icons/vendor_delays.svg',
    //             inactiveImage: 'assets/images/side_icons/vendor_delays-1.svg',
    //             route: '/home/vendordelay',
    //         },
    //     ],
    // },
    {
        title: 'Admin',
        type: 'admin',
        subMenu: [
            {
                title: 'Reports',
                activeImage: 'assets/images/side_icons/finalised_bids.svg',
                inactiveImage: 'assets/images/side_icons/finalised_bids-1.svg',
                route: null,
                subMenu: [
                    {
                        title: 'Transporter',
                        route: '/home/Transporter',
                    },
                    {
                        title: 'Other ',
                        route: '/home/Other',
                    },
                ],
            },
            {
                title: 'Manage Roles',
                activeImage: 'assets/images/side_icons/manage_roles.svg',
                inactiveImage: 'assets/images/side_icons/manage_roles-1.svg',
                route: '/home/manageRoles',
            },
            {
                title: 'User Management',
                activeImage: 'assets/images/side_icons/user_management.svg',
                inactiveImage: 'assets/images/side_icons/user_management-1.svg',
                route: '/home/UserManagement',
            },
        ],
    },
    {
        title: 'Vendors',
        type: 'vendors',
        subMenu: [
            {
                title: 'Manage Categories',
                activeImage: 'assets/images/side_icons/Categoryactive.svg',
                inactiveImage: 'assets/images/side_icons/Categorynotactive.svg',
                route: `/home/categories`,
            },
            {
                title: 'Manage Items',
                activeImage: 'assets/images/side_icons/manageItems.svg',
                inactiveImage: 'assets/images/side_icons/manage_Items_FILL.svg',
                route: `/home/items`,
            },
        ],
    },
    {
        title: 'Mobile App',
        type: 'mobile_app',
        subMenu: [
            {
                title: 'Sign Up Requests',
                activeImage: 'assets/images/side_icons/users.svg',
                inactiveImage: 'assets/images/side_icons/users-1.svg',
                route: '/home/signup_request',
            },
            {
                title: 'Setting',
                activeImage: 'assets/images/side_icons/users.svg',
                inactiveImage: 'assets/images/side_icons/users-1.svg',
                route: '/home/setting',
            },
            {
                title: 'Mobile App Users',
                activeImage: 'assets/images/side_icons/mobile_app_users.svg',
                inactiveImage: 'assets/images/side_icons/mobile_app_users-1.svg',
                route: null,
                subMenu: [
                    {
                        title: 'Transporter',
                        route: '/home/mobile/transporter',
                    },
                    {
                        title: 'Others',
                        route: '/home/mobile/others',
                    },
                ],
            },
            {
                title: 'Notification',
                activeImage: 'assets/images/side_icons/users.svg',
                inactiveImage: 'assets/images/side_icons/users-1.svg',
                route: '/home/mobile/Notification',
            },
        ],
    },
];

const staticData = {
    menuData,
};

export default staticData;
